import { Button } from "~/components/ui/button"

export function InvitationActions({
	pending,
	compact = false,
	onRespond
}: {
	pending?: boolean
	compact?: boolean
	onRespond: (response: "accept" | "decline") => void
}) {
	return (
		<div className="flex gap-2">
			<Button
				variant="outline"
				size={compact ? "sm" : "default"}
				disabled={pending}
				onClick={() => onRespond("decline")}
			>
				Decline
			</Button>
			<Button
				size={compact ? "sm" : "default"}
				disabled={pending}
				onClick={() => onRespond("accept")}
			>
				{compact ? "Accept" : "Accept invitation"}
			</Button>
		</div>
	)
}
